import { updateShopCircle } from '@/services/shopServices';
import {initializeLocalStorageShopCircle, isValidShopCircle, getUserIdFromCookie} from "@/utils/responsive/utils";

export const synchronizeShopCircle = (shopCircleVersion: string)=> {
    return new Promise((resolve, reject) => {
        localStorage.setItem('shopCircleVersion', shopCircleVersion);
        initializeLocalStorageShopCircle(shopCircleVersion);
        let data = {
            "shopCircle": isValidShopCircle() ? localStorage.getItem('shopCircle') : '',
        }
        updateShopCircle(getUserIdFromCookie(), data)
            .then(response => {
                if (response?.data?.shopCircle?.primaryShop) {
                    localStorage.setItem('shopCircle', JSON.stringify(response.data.shopCircle));
                } else {
                    localStorage.removeItem('shopCircle');
                }
                resolve(response);
            })
            .catch((error) => {
                //TODO SES thow exception
                console.log(error);
            })
    })
}